import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { LinearProgress } from '@material-ui/core';
import styled from 'styled-components/macro';
import Label from 'Common/components/Form/Label';
import colors from 'Common/constants/colors';

const Wrapper = styled.div`
    flex: 1;
`;

const Progress = withStyles({
    root: {
        height: 10,
        borderRadius: 5,
    },
    colorPrimary: {
        backgroundColor: colors.PAGE_BACKGROUND,
    },
    bar: {
        borderRadius: 5,
        backgroundColor: colors.PRIMARY,
    },
})(LinearProgress);

const LoadingProgressBar = ({
    progress,
    autoLoading,
    isLoading,
    estimatedLoadingTime,
    label,
    className,
}) => {
    const [customProgress, setCustomProgress] = useState(0);

    useEffect(() => {
        let progressInterval;

        if (estimatedLoadingTime) {
            if (isLoading) {
                const step = (100 / estimatedLoadingTime) * 100;

                progressInterval = setInterval(() => {
                    setCustomProgress(prevProgress => {
                        let nextProgress = prevProgress + step;

                        if (nextProgress >= 95) {
                            nextProgress = prevProgress + step / 10;
                        }

                        if (nextProgress > 100) {
                            nextProgress = 100;
                        }

                        return nextProgress;
                    });
                }, 100);
            } else {
                setCustomProgress(0);
                clearInterval(progressInterval);
            }
        }

        return () => {
            clearInterval(progressInterval);
        };
    }, [estimatedLoadingTime, isLoading]);

    const currentProgress = autoLoading ? customProgress : progress;

    return (
        <Wrapper className={className}>
            {!!label && <Label label={label} />}
            <Progress variant="determinate" value={currentProgress} />
        </Wrapper>
    );
};

LoadingProgressBar.defaultProps = {
    label: undefined,
    progress: undefined,
    autoLoading: false,
    isLoading: false,
    estimatedLoadingTime: undefined,
};

LoadingProgressBar.propTypes = {
    progress: PropTypes.number,
    label: PropTypes.string,
    autoLoading: PropTypes.bool,
    isLoading: PropTypes.bool,
    estimatedLoadingTime: PropTypes.number,
};

export default LoadingProgressBar;
